// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:25
import { OrganizationServiceResource_abstract } from './../abstract/SagaSchema/OrganizationServiceResource_abstract';
export class OrganizationServiceResource extends OrganizationServiceResource_abstract {}
